import React from 'react';
import { func, bool, number, object } from 'prop-types';
import { Button, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { I18n } from 'utils/i18n';
import formik from './formik';
import connector from './connector';

const inputSx = { mb: 2 };

const LoginForm = ({
  values,
  errors,
  submitCount,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => {
  const hasSubmitted = submitCount > 0;
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={inputSx}>
        <TextField
          fullWidth
          error={!!(errors.name && hasSubmitted)}
          helperText={hasSubmitted && errors.name}
          type="text"
          name="name"
          placeholder={I18n.t('NoInvitation.Name and surname')}
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Box>
      <Box sx={inputSx}>
        <TextField
          fullWidth
          error={!!(errors.company && hasSubmitted)}
          helperText={hasSubmitted && errors.company}
          type="text"
          name="company"
          placeholder={I18n.t('NoInvitation.Company name')}
          value={values.company}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Box>
      <Box sx={inputSx}>
        <TextField
          fullWidth
          error={!!(errors.email && hasSubmitted)}
          helperText={hasSubmitted && errors.email}
          type="email"
          name="email"
          placeholder={I18n.t('NoInvitation.Your email address')}
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Box>
      <Button fullWidth variant="contained" type="submit" color="primary" disabled={isSubmitting}>
        {I18n.t('NoInvitation.Send')}
      </Button>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        {errors.server && (
          <Typography align="right" color="error" sx={{ py: '20px' }}>
            {errors.server}
          </Typography>
        )}
      </Box>
    </form>
  );
};

LoginForm.propTypes = {
  values: object.isRequired,
  errors: object.isRequired,
  handleChange: func.isRequired,
  handleBlur: func.isRequired,
  handleSubmit: func.isRequired,
  isSubmitting: bool.isRequired,
  submitCount: number.isRequired,
};

export default connector(formik(LoginForm));
